// GraphQL queries for Payments (proxy membership API)

export const listPaymentsQuery = `
  query ListPayments($input: ListPaymentsInput!) {
    listPayments(input: $input) {
      code
      paymentList {
        paymentId
        companyId
        subscriptionId
        paymentMethod
        paymentStatus
        amount
        currency
        transactionId
        iremboInvoiceNumber
        iremboPaymentLinkUrl
        phoneNumber
        countryCode
        cardLastFour
        cardBrand
        failureReason
        paidAt
        createdAt
        updatedAt
      }
    }
  }
`;

export const getPaymentQuery = `
  query GetPayment($input: GetPaymentInput!) {
    getPayment(input: $input) {
      code
      membershipTokenIssued
      payment {
        paymentId
        companyId
        subscriptionId
        paymentMethod
        paymentStatus
        amount
        currency
        transactionId
        iremboInvoiceNumber
        iremboPaymentLinkUrl
        phoneNumber
        countryCode
        cardLastFour
        cardBrand
        failureReason
        paidAt
        createdAt
        updatedAt
      }
    }
  }
`;

export const createMembershipPaymentMutation = `
  mutation CreateMembershipPayment($input: CreateMembershipPaymentInput!) {
    createMembershipPayment(input: $input) {
      code
      payment {
        paymentId
        companyId
        subscriptionId
        paymentMethod
        paymentStatus
        amount
        currency
        transactionId
        iremboInvoiceNumber
        iremboPaymentLinkUrl
        phoneNumber
        countryCode
        paidAt
        createdAt
        updatedAt
      }
    }
  }
`;

export const createIremboInvoiceMutation = `
  mutation CreateIremboInvoice($input: CreateIremboInvoiceInput!) {
    createIremboInvoice(input: $input) {
      code
      membershipTokenIssued
      invoice {
        invoiceNumber
        transactionId
        paymentAccountIdentifier
        paymentStatus
        amount
        currency
        type
        paymentLinkUrl
        language
        subscriptionActivated
        reconciliationNoOp
      }
    }
  }
`;

export const reconcileIremboPaymentMutation = `
  mutation ReconcileIremboPayment($input: ReconcileIremboPaymentInput!) {
    reconcileIremboPayment(input: $input) {
      code
      membershipTokenIssued
      invoice {
        invoiceNumber
        transactionId
        paymentAccountIdentifier
        paymentStatus
        amount
        currency
        type
        paymentLinkUrl
        language
        subscriptionActivated
        reconciliationNoOp
      }
    }
  }
`;

export const initiateIremboMobileMoneyMutation = `
  mutation InitiateIremboMobileMoney($input: InitiateIremboMobileMoneyInput!) {
    initiateIremboMobileMoney(input: $input) {
      code
      data
    }
  }
`;
